/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: OEpgQT6ESYK5

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { ApiMutationProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/ApiProvider/ApiMutationProvider"; // plasmic-import: appzeORup7Cy/codeComponent
import { FormProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormProvider"; // plasmic-import: R4jbURjT8nMH/codeComponent
import ServiceMessage from "../../ServiceMessage"; // plasmic-import: OnWTFNPo14Tf/component
import { FormControlProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormControlProvider"; // plasmic-import: v9MLUrEpQF_1/codeComponent
import TextInput from "../../TextInput"; // plasmic-import: kx7Qgd3B-3Xa/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import SpinnerIcon from "../../SpinnerIcon"; // plasmic-import: 0R7aXYvaG7Fy/component
import LoginFormSecurity from "../../LoginFormSecurity"; // plasmic-import: 8KallFSuh79l/component
import LoginFormResources from "../../LoginFormResources"; // plasmic-import: cDS26z8R0NcM/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicForgotPasswordForm.module.css"; // plasmic-import: OEpgQT6ESYK5/css

import SearchSvgIcon from "./icons/PlasmicIcon__SearchSvg"; // plasmic-import: 4h8B6qj-XIZa/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

import { zod as __fn_zod } from "@myevaluations/myevals-plasmic-utils/dist/custom-functions/zod"; // plasmic-import: zod/customFunction

createPlasmicElementProxy;

export type PlasmicForgotPasswordForm__VariantMembers = {};
export type PlasmicForgotPasswordForm__VariantsArgs = {};
type VariantPropType = keyof PlasmicForgotPasswordForm__VariantsArgs;
export const PlasmicForgotPasswordForm__VariantProps =
  new Array<VariantPropType>();

export type PlasmicForgotPasswordForm__ArgsType = { onHelpClick?: () => void };
type ArgPropType = keyof PlasmicForgotPasswordForm__ArgsType;
export const PlasmicForgotPasswordForm__ArgProps = new Array<ArgPropType>(
  "onHelpClick"
);

export type PlasmicForgotPasswordForm__OverridesType = {
  root?: Flex__<"div">;
  resetPassword?: Flex__<typeof ApiMutationProvider>;
  forgotPasswordForm?: Flex__<typeof FormProvider>;
  section?: Flex__<"section">;
  wrapper?: Flex__<"div">;
  heading?: Flex__<"div">;
  logo?: Flex__<"a"> & Partial<LinkProps>;
  link?: Flex__<"div">;
  form?: Flex__<"form">;
  header?: Flex__<"div">;
  title?: Flex__<"h1">;
  desc?: Flex__<"p">;
  serviceMessage?: Flex__<typeof ServiceMessage>;
  bottom?: Flex__<"div">;
  email?: Flex__<typeof FormControlProvider>;
  emailWrapper?: Flex__<"div">;
  label?: Flex__<"label">;
  emailInput?: Flex__<typeof TextInput>;
  actions?: Flex__<"div">;
  resetPasswordBtn?: Flex__<typeof Button>;
  spinnerIcon?: Flex__<typeof SpinnerIcon>;
  backToLoginBtn?: Flex__<typeof Button>;
  loginFormSecurity?: Flex__<typeof LoginFormSecurity>;
  loginFormResources?: Flex__<typeof LoginFormResources>;
  line?: Flex__<"div">;
};

export interface DefaultForgotPasswordFormProps {
  onHelpClick?: () => void;
  className?: string;
}

const $$ = {
  zod: __fn_zod
};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicForgotPasswordForm__RenderFunc(props: {
  variants: PlasmicForgotPasswordForm__VariantsArgs;
  args: PlasmicForgotPasswordForm__ArgsType;
  overrides: PlasmicForgotPasswordForm__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "emailInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $ctx.emailProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "isFormSubmitting",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <ApiMutationProvider
        data-plasmic-name={"resetPassword"}
        data-plasmic-override={overrides.resetPassword}
        alertOnError={true}
        className={classNames("__wab_instance", sty.resetPassword)}
        method={"POST"}
        name={"resetPassword"}
        onError={async error => {
          const $steps = {};

          $steps["updateIsFormSubmitting"] = true
            ? (() => {
                const actionArgs = {
                  variable: {
                    objRoot: $state,
                    variablePath: ["isFormSubmitting"]
                  },
                  operation: 0,
                  value: false
                };
                return (({ variable, value, startIndex, deleteCount }) => {
                  if (!variable) {
                    return;
                  }
                  const { objRoot, variablePath } = variable;

                  $stateSet(objRoot, variablePath, value);
                  return value;
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["updateIsFormSubmitting"] != null &&
            typeof $steps["updateIsFormSubmitting"] === "object" &&
            typeof $steps["updateIsFormSubmitting"].then === "function"
          ) {
            $steps["updateIsFormSubmitting"] =
              await $steps["updateIsFormSubmitting"];
          }
        }}
        onLoad={async data => {
          const $steps = {};

          $steps["updateIsFormSubmitting"] = true
            ? (() => {
                const actionArgs = {
                  variable: {
                    objRoot: $state,
                    variablePath: ["isFormSubmitting"]
                  },
                  operation: 0,
                  value: false
                };
                return (({ variable, value, startIndex, deleteCount }) => {
                  if (!variable) {
                    return;
                  }
                  const { objRoot, variablePath } = variable;

                  $stateSet(objRoot, variablePath, value);
                  return value;
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["updateIsFormSubmitting"] != null &&
            typeof $steps["updateIsFormSubmitting"] === "object" &&
            typeof $steps["updateIsFormSubmitting"].then === "function"
          ) {
            $steps["updateIsFormSubmitting"] =
              await $steps["updateIsFormSubmitting"];
          }
        }}
        path={"/New/Api.ashx?path=/auth/forgot-password"}
        throwOnError={true}
      >
        <DataCtxReader__>
          {$ctx => (
            <FormProvider
              data-plasmic-name={"forgotPasswordForm"}
              data-plasmic-override={overrides.forgotPasswordForm}
              className={classNames("__wab_instance", sty.forgotPasswordForm)}
              contextName={"emailForm"}
              mode={"onBlur"}
              reValidateMode={"onChange"}
              zodValidationSchema={(() => {
                try {
                  return (() => {
                    const z = $$.zod();
                    const schema = z.object({
                      email: z
                        .string()
                        .nonempty({ message: "Email field cannot be empty" })
                        .email("Invalid email address")
                        .default("")
                    });
                    return schema;
                  })();
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            >
              <DataCtxReader__>
                {$ctx => (
                  <section
                    data-plasmic-name={"section"}
                    data-plasmic-override={overrides.section}
                    className={classNames(projectcss.all, sty.section)}
                  >
                    <div
                      data-plasmic-name={"wrapper"}
                      data-plasmic-override={overrides.wrapper}
                      className={classNames(projectcss.all, sty.wrapper)}
                    >
                      <div
                        data-plasmic-name={"heading"}
                        data-plasmic-override={overrides.heading}
                        className={classNames(projectcss.all, sty.heading)}
                      >
                        {(
                          hasVariant(globalVariants, "mobile", "mobile")
                            ? true
                            : hasVariant(
                                  globalVariants,
                                  "mobile",
                                  "tabletPortrait"
                                )
                              ? true
                              : false
                        ) ? (
                          <PlasmicLink__
                            data-plasmic-name={"logo"}
                            data-plasmic-override={overrides.logo}
                            aria-label={"Home"}
                            className={classNames(
                              projectcss.all,
                              projectcss.a,
                              sty.logo
                            )}
                            component={Link}
                            href={`/`}
                            legacyBehavior={false}
                            platform={"nextjs"}
                            title={"Home"}
                          >
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__e7Nxd)}
                              displayHeight={
                                hasVariant(
                                  globalVariants,
                                  "mobile",
                                  "mobileXSmall"
                                )
                                  ? "32px"
                                  : "36px"
                              }
                              displayMaxHeight={"none"}
                              displayMaxWidth={"100%"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={
                                hasVariant(
                                  globalVariants,
                                  "mobile",
                                  "mobileXSmall"
                                )
                                  ? "180px"
                                  : "205px"
                              }
                              loader={"plasmic"}
                              loading={"lazy"}
                              src={{
                                src: "https://site-assets.plasmic.app/aaa816ed07b668d50951fc51e9c19c16.svg",
                                fullWidth: 170.666,
                                fullHeight: 29.831,
                                aspectRatio: 5.7
                              }}
                            />
                          </PlasmicLink__>
                        ) : null}
                        <div
                          data-plasmic-name={"link"}
                          data-plasmic-override={overrides.link}
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.link
                          )}
                        >
                          {hasVariant(globalVariants, "mobile", "mobile") ? (
                            <React.Fragment>
                              <React.Fragment>{""}</React.Fragment>
                              {
                                <PlasmicLink__
                                  aria-label={"Open help logging in modal"}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.a,
                                    projectcss.__wab_text,
                                    projectcss.plasmic_default__inline,
                                    sty.link__rfVAo
                                  )}
                                  component={Link}
                                  legacyBehavior={false}
                                  onClick={async event => {
                                    const $steps = {};

                                    $steps["runOnHelpClick"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            eventRef: $props["onHelpClick"]
                                          };
                                          return (({ eventRef, args }) => {
                                            return eventRef?.(...(args ?? []));
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["runOnHelpClick"] != null &&
                                      typeof $steps["runOnHelpClick"] ===
                                        "object" &&
                                      typeof $steps["runOnHelpClick"].then ===
                                        "function"
                                    ) {
                                      $steps["runOnHelpClick"] =
                                        await $steps["runOnHelpClick"];
                                    }
                                  }}
                                  platform={"nextjs"}
                                  title={"Open help logging in modal"}
                                >
                                  {hasVariant(
                                    globalVariants,
                                    "mobile",
                                    "mobile"
                                  )
                                    ? "Need Help?"
                                    : hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                      ? "Need Help?"
                                      : "Need Help Logging In?"}
                                </PlasmicLink__>
                              }
                              <React.Fragment>{""}</React.Fragment>
                            </React.Fragment>
                          ) : hasVariant(
                              globalVariants,
                              "mobile",
                              "tabletPortrait"
                            ) ? (
                            <React.Fragment>
                              <React.Fragment>{""}</React.Fragment>
                              {
                                <PlasmicLink__
                                  aria-label={"Open help logging in modal"}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.a,
                                    projectcss.__wab_text,
                                    projectcss.plasmic_default__inline,
                                    sty.link__rfVAo
                                  )}
                                  component={Link}
                                  legacyBehavior={false}
                                  onClick={async event => {
                                    const $steps = {};

                                    $steps["runOnHelpClick"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            eventRef: $props["onHelpClick"]
                                          };
                                          return (({ eventRef, args }) => {
                                            return eventRef?.(...(args ?? []));
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["runOnHelpClick"] != null &&
                                      typeof $steps["runOnHelpClick"] ===
                                        "object" &&
                                      typeof $steps["runOnHelpClick"].then ===
                                        "function"
                                    ) {
                                      $steps["runOnHelpClick"] =
                                        await $steps["runOnHelpClick"];
                                    }
                                  }}
                                  platform={"nextjs"}
                                  title={"Open help logging in modal"}
                                >
                                  {hasVariant(
                                    globalVariants,
                                    "mobile",
                                    "mobile"
                                  )
                                    ? "Need Help?"
                                    : hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                      ? "Need Help?"
                                      : "Need Help Logging In?"}
                                </PlasmicLink__>
                              }
                              <React.Fragment>{""}</React.Fragment>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <React.Fragment>{""}</React.Fragment>
                              {
                                <PlasmicLink__
                                  aria-label={"Open help logging in modal"}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.a,
                                    projectcss.__wab_text,
                                    projectcss.plasmic_default__inline,
                                    sty.link__rfVAo
                                  )}
                                  component={Link}
                                  legacyBehavior={false}
                                  onClick={async event => {
                                    const $steps = {};

                                    $steps["runOnHelpClick"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            eventRef: $props["onHelpClick"]
                                          };
                                          return (({ eventRef, args }) => {
                                            return eventRef?.(...(args ?? []));
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["runOnHelpClick"] != null &&
                                      typeof $steps["runOnHelpClick"] ===
                                        "object" &&
                                      typeof $steps["runOnHelpClick"].then ===
                                        "function"
                                    ) {
                                      $steps["runOnHelpClick"] =
                                        await $steps["runOnHelpClick"];
                                    }
                                  }}
                                  platform={"nextjs"}
                                  title={"Open help logging in modal"}
                                >
                                  {hasVariant(
                                    globalVariants,
                                    "mobile",
                                    "mobile"
                                  )
                                    ? "Need Help?"
                                    : hasVariant(
                                          globalVariants,
                                          "mobile",
                                          "tabletPortrait"
                                        )
                                      ? "Need Help?"
                                      : "Need Help Logging In?"}
                                </PlasmicLink__>
                              }
                              <React.Fragment>{""}</React.Fragment>
                            </React.Fragment>
                          )}
                        </div>
                      </div>
                      <form
                        data-plasmic-name={"form"}
                        data-plasmic-override={overrides.form}
                        className={classNames(projectcss.all, sty.form)}
                        onSubmit={async event => {
                          const $steps = {};

                          $steps["runCode"] = !$state.isFormSubmitting
                            ? (() => {
                                const actionArgs = {
                                  customFunction: async () => {
                                    return (() => {
                                      event.preventDefault();
                                      const onFinish = () => {
                                        const onSubmit = values => {
                                          $state.isFormSubmitting = true;
                                          $ctx.resetPassword
                                            .trigger({
                                              body: { email: values.email }
                                            })
                                            .then(response => {
                                              $ctx.toast.show({
                                                id: "1",
                                                type: "success",
                                                title: "Request Received",
                                                description: response.message
                                              });
                                            })
                                            .catch(() => {
                                              $ctx.toast.show({
                                                id: "1",
                                                type: "error",
                                                title: "Server Error",
                                                description:
                                                  "Your form hasn\u2019t been submitted. Try again."
                                              });
                                            });
                                        };
                                        const onError = () => {
                                          const error =
                                            $ctx.emailForm.control._formState
                                              .errors?.email?.message;
                                          $ctx.toast.show({
                                            id: "1",
                                            type: "error",
                                            title:
                                              error === "Invalid email address"
                                                ? "Invalid Email"
                                                : "Incomplete Form",
                                            description: error
                                          });
                                        };
                                        return $ctx.emailForm.handleSubmit(
                                          onSubmit,
                                          onError
                                        )();
                                      };
                                      return onFinish();
                                    })();
                                  }
                                };
                                return (({ customFunction }) => {
                                  return customFunction();
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["runCode"] != null &&
                            typeof $steps["runCode"] === "object" &&
                            typeof $steps["runCode"].then === "function"
                          ) {
                            $steps["runCode"] = await $steps["runCode"];
                          }
                        }}
                      >
                        <div
                          data-plasmic-name={"header"}
                          data-plasmic-override={overrides.header}
                          className={classNames(projectcss.all, sty.header)}
                        >
                          <h1
                            data-plasmic-name={"title"}
                            data-plasmic-override={overrides.title}
                            className={classNames(
                              projectcss.all,
                              projectcss.h1,
                              projectcss.__wab_text,
                              sty.title
                            )}
                          >
                            {"Forgot Password"}
                          </h1>
                          <p
                            data-plasmic-name={"desc"}
                            data-plasmic-override={overrides.desc}
                            className={classNames(
                              projectcss.all,
                              projectcss.p,
                              projectcss.__wab_text,
                              sty.desc
                            )}
                          >
                            {"We\u2019ll help you access your account"}
                          </p>
                        </div>
                        <ServiceMessage
                          data-plasmic-name={"serviceMessage"}
                          data-plasmic-override={overrides.serviceMessage}
                          className={classNames(
                            "__wab_instance",
                            sty.serviceMessage
                          )}
                          rounded={true}
                        />

                        <div
                          data-plasmic-name={"bottom"}
                          data-plasmic-override={overrides.bottom}
                          className={classNames(projectcss.all, sty.bottom)}
                        >
                          <FormControlProvider
                            data-plasmic-name={"email"}
                            data-plasmic-override={overrides.email}
                            className={classNames("__wab_instance", sty.email)}
                            contextName={"emailProvider"}
                            fieldName={"email"}
                            formControl={(() => {
                              try {
                                return $ctx.emailForm.control;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return undefined;
                                }
                                throw e;
                              }
                            })()}
                          >
                            <DataCtxReader__>
                              {$ctx => (
                                <div
                                  data-plasmic-name={"emailWrapper"}
                                  data-plasmic-override={overrides.emailWrapper}
                                  className={classNames(
                                    projectcss.all,
                                    sty.emailWrapper
                                  )}
                                >
                                  <label
                                    data-plasmic-name={"label"}
                                    data-plasmic-override={overrides.label}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.__wab_text,
                                      sty.label
                                    )}
                                  >
                                    {"Email"}
                                  </label>
                                  {(() => {
                                    const child$Props = {
                                      "aria-label": "Email",
                                      autoFocus: true,
                                      className: classNames(
                                        "__wab_instance",
                                        sty.emailInput
                                      ),
                                      invalid: (() => {
                                        try {
                                          return $ctx.emailProvider.fieldState
                                            .invalid;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return [];
                                          }
                                          throw e;
                                        }
                                      })(),
                                      name: "email",
                                      onChange: async (...eventArgs: any) => {
                                        ((...eventArgs) => {
                                          generateStateOnChangeProp($state, [
                                            "emailInput",
                                            "value"
                                          ])(
                                            (e => e.target?.value).apply(
                                              null,
                                              eventArgs
                                            )
                                          );
                                        }).apply(null, eventArgs);

                                        if (
                                          eventArgs.length > 1 &&
                                          eventArgs[1] &&
                                          eventArgs[1]._plasmic_state_init_
                                        ) {
                                          return;
                                        }

                                        (async event => {
                                          const $steps = {};

                                          $steps["runCode"] = true
                                            ? (() => {
                                                const actionArgs = {
                                                  customFunction: async () => {
                                                    return $ctx.emailProvider.field.onChange(
                                                      event.target.value
                                                    );
                                                  }
                                                };
                                                return (({
                                                  customFunction
                                                }) => {
                                                  return customFunction();
                                                })?.apply(null, [actionArgs]);
                                              })()
                                            : undefined;
                                          if (
                                            $steps["runCode"] != null &&
                                            typeof $steps["runCode"] ===
                                              "object" &&
                                            typeof $steps["runCode"].then ===
                                              "function"
                                          ) {
                                            $steps["runCode"] =
                                              await $steps["runCode"];
                                          }
                                        }).apply(null, eventArgs);
                                      },
                                      placeholder: ``,
                                      required: true,
                                      size: "large",
                                      type: "email",
                                      value:
                                        generateStateValueProp($state, [
                                          "emailInput",
                                          "value"
                                        ]) ?? ""
                                    };

                                    initializePlasmicStates(
                                      $state,
                                      [
                                        {
                                          name: "emailInput.value",
                                          initFunc: ({
                                            $props,
                                            $state,
                                            $queries,
                                            $q
                                          }) =>
                                            (() => {
                                              try {
                                                return $ctx.emailProvider.field
                                                  .value;
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                    "PlasmicUndefinedDataError"
                                                ) {
                                                  return undefined;
                                                }
                                                throw e;
                                              }
                                            })()
                                        }
                                      ],
                                      []
                                    );
                                    return (
                                      <TextInput
                                        data-plasmic-name={"emailInput"}
                                        data-plasmic-override={
                                          overrides.emailInput
                                        }
                                        {...child$Props}
                                      />
                                    );
                                  })()}
                                </div>
                              )}
                            </DataCtxReader__>
                          </FormControlProvider>
                          <div
                            data-plasmic-name={"actions"}
                            data-plasmic-override={overrides.actions}
                            className={classNames(projectcss.all, sty.actions)}
                          >
                            <Button
                              data-plasmic-name={"resetPasswordBtn"}
                              data-plasmic-override={overrides.resetPasswordBtn}
                              aria-label={"Reset password"}
                              className={classNames(
                                "__wab_instance",
                                sty.resetPasswordBtn
                              )}
                              color={"primary"}
                              size={"large"}
                              submitsForm={true}
                            >
                              {(() => {
                                try {
                                  return !$state.isFormSubmitting;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return true;
                                  }
                                  throw e;
                                }
                              })() ? (
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.text___38MSa
                                  )}
                                >
                                  {"SUBMIT"}
                                </div>
                              ) : null}
                              {(() => {
                                try {
                                  return $state.isFormSubmitting;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return false;
                                  }
                                  throw e;
                                }
                              })() ? (
                                <SpinnerIcon
                                  data-plasmic-name={"spinnerIcon"}
                                  data-plasmic-override={overrides.spinnerIcon}
                                  className={classNames(
                                    "__wab_instance",
                                    sty.spinnerIcon
                                  )}
                                  light={true}
                                />
                              ) : null}
                            </Button>
                            <Button
                              data-plasmic-name={"backToLoginBtn"}
                              data-plasmic-override={overrides.backToLoginBtn}
                              aria-label={"Go to login page"}
                              className={classNames(
                                "__wab_instance",
                                sty.backToLoginBtn
                              )}
                              color={"sky"}
                              link={`/login`}
                              size={"large"}
                              submitsForm={false}
                            >
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text__ydY34
                                )}
                              >
                                {"Back to login"}
                              </div>
                            </Button>
                          </div>
                          <LoginFormSecurity
                            data-plasmic-name={"loginFormSecurity"}
                            data-plasmic-override={overrides.loginFormSecurity}
                            className={classNames(
                              "__wab_instance",
                              sty.loginFormSecurity
                            )}
                            noPadding={true}
                          />

                          <LoginFormResources
                            data-plasmic-name={"loginFormResources"}
                            data-plasmic-override={overrides.loginFormResources}
                            className={classNames(
                              "__wab_instance",
                              sty.loginFormResources
                            )}
                          />
                        </div>
                      </form>
                      {(
                        hasVariant(globalVariants, "mobile", "mobile")
                          ? false
                          : hasVariant(
                                globalVariants,
                                "mobile",
                                "tabletPortrait"
                              )
                            ? false
                            : true
                      ) ? (
                        <div
                          data-plasmic-name={"line"}
                          data-plasmic-override={overrides.line}
                          className={classNames(projectcss.all, sty.line)}
                        >
                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__aeFzs)}
                            displayHeight={"auto"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"100%"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"auto"}
                            loader={"plasmic"}
                            loading={"lazy"}
                            src={{
                              src: "https://img.plasmic.app/img-optimizer/v1/img/5d12c32e575d64afdd9b248fa1ad93de.png",
                              fullWidth: 475,
                              fullHeight: 310
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                  </section>
                )}
              </DataCtxReader__>
            </FormProvider>
          )}
        </DataCtxReader__>
      </ApiMutationProvider>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "resetPassword",
    "forgotPasswordForm",
    "section",
    "wrapper",
    "heading",
    "logo",
    "link",
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "bottom",
    "email",
    "emailWrapper",
    "label",
    "emailInput",
    "actions",
    "resetPasswordBtn",
    "spinnerIcon",
    "backToLoginBtn",
    "loginFormSecurity",
    "loginFormResources",
    "line"
  ],
  resetPassword: [
    "resetPassword",
    "forgotPasswordForm",
    "section",
    "wrapper",
    "heading",
    "logo",
    "link",
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "bottom",
    "email",
    "emailWrapper",
    "label",
    "emailInput",
    "actions",
    "resetPasswordBtn",
    "spinnerIcon",
    "backToLoginBtn",
    "loginFormSecurity",
    "loginFormResources",
    "line"
  ],
  forgotPasswordForm: [
    "forgotPasswordForm",
    "section",
    "wrapper",
    "heading",
    "logo",
    "link",
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "bottom",
    "email",
    "emailWrapper",
    "label",
    "emailInput",
    "actions",
    "resetPasswordBtn",
    "spinnerIcon",
    "backToLoginBtn",
    "loginFormSecurity",
    "loginFormResources",
    "line"
  ],
  section: [
    "section",
    "wrapper",
    "heading",
    "logo",
    "link",
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "bottom",
    "email",
    "emailWrapper",
    "label",
    "emailInput",
    "actions",
    "resetPasswordBtn",
    "spinnerIcon",
    "backToLoginBtn",
    "loginFormSecurity",
    "loginFormResources",
    "line"
  ],
  wrapper: [
    "wrapper",
    "heading",
    "logo",
    "link",
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "bottom",
    "email",
    "emailWrapper",
    "label",
    "emailInput",
    "actions",
    "resetPasswordBtn",
    "spinnerIcon",
    "backToLoginBtn",
    "loginFormSecurity",
    "loginFormResources",
    "line"
  ],
  heading: ["heading", "logo", "link"],
  logo: ["logo"],
  link: ["link"],
  form: [
    "form",
    "header",
    "title",
    "desc",
    "serviceMessage",
    "bottom",
    "email",
    "emailWrapper",
    "label",
    "emailInput",
    "actions",
    "resetPasswordBtn",
    "spinnerIcon",
    "backToLoginBtn",
    "loginFormSecurity",
    "loginFormResources"
  ],
  header: ["header", "title", "desc"],
  title: ["title"],
  desc: ["desc"],
  serviceMessage: ["serviceMessage"],
  bottom: [
    "bottom",
    "email",
    "emailWrapper",
    "label",
    "emailInput",
    "actions",
    "resetPasswordBtn",
    "spinnerIcon",
    "backToLoginBtn",
    "loginFormSecurity",
    "loginFormResources"
  ],
  email: ["email", "emailWrapper", "label", "emailInput"],
  emailWrapper: ["emailWrapper", "label", "emailInput"],
  label: ["label"],
  emailInput: ["emailInput"],
  actions: ["actions", "resetPasswordBtn", "spinnerIcon", "backToLoginBtn"],
  resetPasswordBtn: ["resetPasswordBtn", "spinnerIcon"],
  spinnerIcon: ["spinnerIcon"],
  backToLoginBtn: ["backToLoginBtn"],
  loginFormSecurity: ["loginFormSecurity"],
  loginFormResources: ["loginFormResources"],
  line: ["line"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  resetPassword: typeof ApiMutationProvider;
  forgotPasswordForm: typeof FormProvider;
  section: "section";
  wrapper: "div";
  heading: "div";
  logo: "a";
  link: "div";
  form: "form";
  header: "div";
  title: "h1";
  desc: "p";
  serviceMessage: typeof ServiceMessage;
  bottom: "div";
  email: typeof FormControlProvider;
  emailWrapper: "div";
  label: "label";
  emailInput: typeof TextInput;
  actions: "div";
  resetPasswordBtn: typeof Button;
  spinnerIcon: typeof SpinnerIcon;
  backToLoginBtn: typeof Button;
  loginFormSecurity: typeof LoginFormSecurity;
  loginFormResources: typeof LoginFormResources;
  line: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicForgotPasswordForm__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicForgotPasswordForm__VariantsArgs;
    args?: PlasmicForgotPasswordForm__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicForgotPasswordForm__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicForgotPasswordForm__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicForgotPasswordForm__ArgProps,
          internalVariantPropNames: PlasmicForgotPasswordForm__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicForgotPasswordForm__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicForgotPasswordForm";
  } else {
    func.displayName = `PlasmicForgotPasswordForm.${nodeName}`;
  }
  return func;
}

export const PlasmicForgotPasswordForm = Object.assign(
  // Top-level PlasmicForgotPasswordForm renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    resetPassword: makeNodeComponent("resetPassword"),
    forgotPasswordForm: makeNodeComponent("forgotPasswordForm"),
    section: makeNodeComponent("section"),
    wrapper: makeNodeComponent("wrapper"),
    heading: makeNodeComponent("heading"),
    logo: makeNodeComponent("logo"),
    link: makeNodeComponent("link"),
    form: makeNodeComponent("form"),
    header: makeNodeComponent("header"),
    title: makeNodeComponent("title"),
    desc: makeNodeComponent("desc"),
    serviceMessage: makeNodeComponent("serviceMessage"),
    bottom: makeNodeComponent("bottom"),
    email: makeNodeComponent("email"),
    emailWrapper: makeNodeComponent("emailWrapper"),
    label: makeNodeComponent("label"),
    emailInput: makeNodeComponent("emailInput"),
    actions: makeNodeComponent("actions"),
    resetPasswordBtn: makeNodeComponent("resetPasswordBtn"),
    spinnerIcon: makeNodeComponent("spinnerIcon"),
    backToLoginBtn: makeNodeComponent("backToLoginBtn"),
    loginFormSecurity: makeNodeComponent("loginFormSecurity"),
    loginFormResources: makeNodeComponent("loginFormResources"),
    line: makeNodeComponent("line"),

    // Metadata about props expected for PlasmicForgotPasswordForm
    internalVariantProps: PlasmicForgotPasswordForm__VariantProps,
    internalArgProps: PlasmicForgotPasswordForm__ArgProps
  }
);

export default PlasmicForgotPasswordForm;
/* prettier-ignore-end */
